// extracted by mini-css-extract-plugin
export default {"lock":"RescheduleClassRow_lock__GZppB","locked":"RescheduleClassRow_locked__2FADw"};